import React, { useContext } from "react";
import { ContextoListaApartamentos } from "../../ApartamentList/contextoImoveis";
const ProgressBar = (props) => {
  const { tema } = useContext(ContextoListaApartamentos);
  const { completed } = props;

  const containerStyles = {
    height: 12,
    width: "100%",
    backgroundColor: "#F7F5F4",
    borderRadius: 50,
    transition: "0.3s",
  };

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    backgroundColor: `${completed === 100 ? tema.primaryColor : "#B1B3B3"}`,
    borderRadius: "inherit",
    textAlign: "right",
    transition: "0.3s",
  };

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;
